"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var destination_1 = require("../destination");
var columns_destination_1 = require("./columns-destination");
var header_footer_reference_destination_base_1 = require("./header-footer/header-footer-reference-destination-base");
var section_different_first_page_destination_1 = require("./section-different-first-page-destination");
var section_margins_destination_1 = require("./section-margins-destination");
var section_page_numbering_destination_1 = require("./section-page-numbering-destination");
var section_page_size_destination_1 = require("./section-page-size-destination");
var section_start_type_destination_1 = require("./section-start-type-destination");
var section_line_numbering_destination_1 = require("./section-line-numbering-destination");
var SectionDestination = (function (_super) {
    tslib_1.__extends(SectionDestination, _super);
    function SectionDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SectionDestination.prototype, "elementHandlerTable", {
        get: function () {
            return SectionDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    SectionDestination.handlerTable = new map_creator_1.MapCreator()
        .add('cols', function (data) { return new columns_destination_1.ColumnsDestination(data); })
        .add('lnNumType', function (data) { return new section_line_numbering_destination_1.SectionLineNumberingDestination(data); })
        .add('pgNumType', function (data) { return new section_page_numbering_destination_1.SectionPageNumberingDestination(data); })
        .add('paperSrc', function (_data) { return null; })
        .add('pgMar', function (data) { return new section_margins_destination_1.SectionMarginsDestination(data); })
        .add('pgSz', function (data) { return new section_page_size_destination_1.SectionPageSizeDestination(data); })
        .add('textDirection', function (_data) { return null; })
        .add('textFlow', function (_data) { return null; })
        .add('vAlign', function (_data) { return null; })
        .add('bidi', function (_data) { return null; })
        .add('type', function (data) { return new section_start_type_destination_1.SectionStartTypeDestination(data); })
        .add('headerReference', function (data) { return new header_footer_reference_destination_base_1.HeaderReferenceDestination(data); })
        .add('footerReference', function (data) { return new header_footer_reference_destination_base_1.FooterReferenceDestination(data); })
        .add('titlePg', function (data) { return new section_different_first_page_destination_1.SectionDifferentFirstPageDestination(data); })
        .add('footnotePr', function (_data) { return null; })
        .add('endnotePr', function (_data) { return null; })
        .get();
    return SectionDestination;
}(destination_1.ElementDestination));
exports.SectionDestination = SectionDestination;
